//Library
import React, { Component } from 'react';
import md5 from 'md5';
import Swal from 'sweetalert2';
import { isMobile } from 'react-device-detect';
//redux
import { connect } from 'react-redux';
import { stepTsrComplete } from '../../action/anueInfoAction';

class Step2 extends Component {

    stepClick() {
        if (document.getElementById("agreeblock").checked === false) {
            Swal.fire("請點選 詳閱公開說明書、投資人須知、通路報酬與風險預告");
            return false;
        } else if (document.getElementById("pwd").value === "") {
            Swal.fire("請輸入密碼");
            return false;
        } else {
            let data = {
                outFundID: this.props.TSRDataInfo.outFundID,
                inFundID: this.props.selectTsrFund.fundID,
                sourceCode: (isMobile) ? 3 : 1,
                pwd: md5(document.getElementById("pwd").value),
                ip: "",
                sid: this.props.TSRDataInfo.sid
            }

            this.props.stepTsrComplete(data, () => {
                this.props.nextStep();
            })
        }
    }

    render() {
        return <fieldset>
            <div className="featureBox">
                <div className="fundconfirmingblock">
                    <div className="blackTitle hrspace">
                        <span>好日子 - 帳戶庫存</span>
                        <div className="hr"></div>
                    </div>
                    <div>
                        <div className="fundlist">
                            <div className="fundlisttitle">轉出基金名稱</div>
                            {
                                this.props.TSRDataInfo !== undefined ?
                                    <div className="fundnameold fundtextstyle">（{this.props.TSRDataInfo.outFundID}）{this.props.TSRDataInfo.outFundName}</div> : ""
                            }
                        </div>
                        <div className="fundlist">
                            <div className="fundlisttitle">轉出單位數</div>
                            <div className="fundamount listtextstyle">
                                {
                                    this.props.TSRDataInfo !== undefined ? this.props.TSRDataInfo.tsrUnit : ""
                                }
                            </div>
                        </div>
                        <div className="fundlist">
                            <div className="fundlisttitle">轉入基金名稱</div>
                            <div className="fundnamenew fundtextstyle">
                                {
                                    this.props.selectTsrFund !== undefined ? "（" + this.props.selectTsrFund.fundID + "）" + this.props.selectTsrFund.shortName : ""
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grayhr"></div>
                {
                    this.props.TSRDataInfo !== undefined && this.props.TSRDataInfo.rspDay !== "" ?
                        <div className="fundconfirmingblock">
                            <div className="blackTitle hrspace">
                                <span>好日子 - 定期定額</span>
                                <div className="hr"></div>
                            </div>
                            <div>
                                <div className="fundlist">
                                    <div className="fundlisttitle">終止扣款基金</div>
                                    <div className="fundnameold fundtextstyle">{this.props.TSRDataInfo !== undefined ? "（" + this.props.TSRDataInfo.outFundID + "）" + this.props.TSRDataInfo.outFundName : ""}</div>
                                </div>
                                <div className="fundlist">
                                    <div className="fundlisttitle">新增扣款基金</div>
                                    <div className="fundnamenew fundtextstyle">
                                        {
                                            this.props.selectTsrFund !== undefined ? "（" + this.props.selectTsrFund.fundID + "）" + this.props.selectTsrFund.shortName : ""
                                        }
                                    </div>
                                </div>
                                <div className="fundlist">
                                    <div className="fundlisttitle">扣款日</div>
                                    <div className="funddeductiondate listtextstyle">{this.props.TSRDataInfo.rspDay}</div>
                                </div>
                                <div className="fundlist">
                                    <div className="fundlisttitle">扣款金額</div>
                                    <div className="funddeductionsum listtextstyle">{this.props.TSRDataInfo.trCcyCodeDesc}{this.props.TSRDataInfo.rspAmt}元</div>
                                </div>
                                <div className="fundlist">
                                    <div className="fundlisttitle">手續費率</div>
                                    <div className="funddeductionrate listtextstyle">{this.props.TSRDataInfo.feeRate}%</div>
                                </div>
                                <div className="fundlist">
                                    <div className="fundlisttitle">扣款帳號</div>
                                    <div className="funddeductionaccount listtextstyle">{this.props.TSRDataInfo.bankCodeDesc + " " + this.props.TSRDataInfo.accNo}</div>
                                </div>
                            </div>
                        </div> : ""
                }

                <div className="fileblock">
                    <h3>投資人須知、公開說明書、通路報酬與風險預告</h3>
                    <span className="fundtextstyle">
                        {this.props.selectTsrFund !== undefined ? "（" + this.props.selectTsrFund.fundID + "）" + this.props.selectTsrFund.shortName : ""}
                    </span>
                    <ul>
                        <li><a rel="noopener noreferrer" href={this.props.selectPDF !== undefined ? this.props.selectPDF[0].investorInfo : ""} target="_blank">投資人須知</a></li>
                        <li><a rel="noopener noreferrer" href={this.props.selectPDF !== undefined ? this.props.selectPDF[0].prospectus : ""} target="_blank">公開說明書</a></li>
                        <li><a rel="noopener noreferrer" href={this.props.selectPDF !== undefined ? this.props.selectPDF[0].profit : ""} target="_blank">通路報酬</a></li>
                        <li><a rel="noopener noreferrer" href="./assets/pdf/Risk.pdf" target="_blank">風險預告</a></li>
                    </ul>
                </div>
            </div>
            <input type="checkbox" name="agree" value="agree" id="agreeblock" />
            <label for="agreeblock">本人已於交易前詳閱公開說明書、投資人須知、通路報酬與風險預告</label>

            <div className="passwordblock">交易密碼<input id="pwd" type="password" name="password" placeholder="請輸入交易密碼" /></div>

            <input type="button" name="previous" className="previous btnbackblock" value="回上一步" onClick={this.props.prevStep} />
            <input type="button" name="next" className="next btnblock" value="下一步" onClick={() => { this.stepClick() }} />
        </fieldset>
    }

}
function mapStateToProps(state) {
    return {
        TSRDataInfo: state.anueInfoState.TSRDataInfo,
        selectTsrFund: state.anueInfoState.selectTsrFund,
        selectPDF: state.anueInfoState.selectPDF,
    };
}
export default connect(mapStateToProps, { stepTsrComplete })(Step2);